module.exports = __webpack_public_path__ + "static/scale-model-of-friendship-archway-in-alexandria-virginia-21729d1d29b37f42c89023537635b377.png";